<template>
  <div class="sidebar">
    <div class="sidebar-header" >
      <h3>服务平台</h3>
    </div>
    <el-menu
      :default-active="$route.path"
      text-color="#333"
      active-text-color="#165DFF"
      ref="menu"
      @select="handleMenuSelect"
    >
      <el-menu-item
        v-for="item in menuItems"
        :key="item.menuCode"
        :index="item.menuUrl"
      >
        <!-- <i :class="item.iconClass"></i> -->
        <el-image
          style="width: 13px;height: 13px;margin-right: 10px;"
          :src="require(`@/static/images/service-icon/slideBar/${$route.path === item.menuUrl ? 'activity' : ''}${item.menuCode}.png`)">
        </el-image>
        <span slot="title">{{ item.menuName }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { getMenuList } from '@/api/serviceDashbord'
export default {
  data() {
    return {
      menuItems: [],
      menuLoaded: false // 添加加载状态标识
    }
  },
  methods: {
    getMenuItems() {
      if (this.menuLoaded) return
      getMenuList().then(res => {
        const processedMenu = res.resultData.map(item => ({
          ...item,
          menuUrl: '/service/' + item.menuCode
        }))
        // 存入Vuex和本地缓存
        this.$store.commit('SET_MENU', processedMenu)
        localStorage.setItem('cachedMenu', JSON.stringify(processedMenu))
        this.menuItems = processedMenu
      })
    },
    handleMenuSelect(index) {
      // 判断是否是退出菜单
      const selectedMenu = this.menuItems.find(item => item.menuUrl === index)
      console.log(index, 'idex')
      if (selectedMenu && selectedMenu.menuCode === 'exit') {
        // 处理退出逻辑
        this.$store.dispatch('userOutLogin').then(() => {
          this.$router.push('/public/service/login')
        })
      } else {
        // 避免重复跳转到当前路径
        if (this.$route.path !== index) {
          this.$router.push(index)
        }
      }
    },
    // 初始化时优先从缓存读取
    initMenu() {
      const cached = localStorage.getItem('cachedMenu')
      if (cached) {
        this.menuItems = JSON.parse(cached)
        this.menuLoaded = true
      }
      this.getMenuItems() // 仍然请求最新数据
    }
  },
  watch: {
    '$route'(to) {
      // 只有当路由是/service下的路径时才保持菜单激活状态
      if (to.path.startsWith('/service')) {
        this.$nextTick(() => {
          // 强制更新菜单激活状态
          this.$refs.menu?.updateActiveIndex()
        })
      }
    }
  },
  mounted() {
    this.initMenu() // 修改初始化方法
  }
}
</script>

<style lang="scss" scoped>

.el-menu {
  border-right: none;
}
.sidebar {
  width: 200px;
  min-height: 80vh;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;

  background-image: url('../static/images/service-icon/leftMenu.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  border: 1px solid #E4E4E4; // 边框
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08); // 阴影
  border-radius: 8px; // 圆角
  transition: all 0.3s ease;
  .sidebar-header {
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    background: #045ad5;
    coLor: #fff;
    border-bottom: 1px solid #E4E4E4;
    h3 {
      margin: 0;
      padding: 0;
    }
  }
  .el-menu {
    /* 禁用菜单项的hover背景色 */
    background: transparent;
    .el-menu-item {
      &:hover {
        background-color: transparent !important;
      }
      
      /* 激活状态样式 */
      &.is-active {
        background-color: rgba(22, 93, 255, 0.1);
      }
    }
  }
}
</style>
